import { t } from "i18next";

export default function validate(values) {

  let errors = {};

  const requiredFields = true;
  const validateRegexFields = true;
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      //console.log("--->email, !values.email", !values.email);
        //console.log("--->email, values.email", values.email);
       //console.log("--->email, values.email !== ", values.email !== "");

  if (requiredFields) {
    //console.log("Caso A, requiredFields");
    if (!values.email) {
      addMessageToErrors(`* ${t("validations.email-login")} ${t("validations.required")}`, "email", errors);
    }

  }

  if (validateRegexFields) {
    //console.log("Caso B, validateRegexFields")
    if (values.email !== "" ) {
      if (!regexEmail.test(values.email)) {
        addMessageToErrors(`* ${t("validations.email-login")} ${t("validations.email-format")}`, "email", errors);
      }
    }
  }

  return errors;
};

const addMessageToErrors = (textToAdd, field, errorsLocal) => {
  //console.log("addMessageToErrors, field, textToAdd", field, textToAdd)
  if (errorsLocal[field]) {
    errorsLocal[field] = `${errorsLocal[field]}\n${textToAdd}`;
  } else {
    errorsLocal[field] = `${textToAdd}`;
  }
}
